<template>
  <v-menu
    v-model="menu1"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="value"
        :label="label"
        :prepend-icon="withIcon ? 'mdi-calendar' : undefined"
        append-icon="mdi-menu-down"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="dateFormated" @input="menu1 = false"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
    name: "PickDate",
    props: {
        value: {
            type: String
        },
        label: {
            type: String,
            default: 'Date'
        },
        withIcon: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            menu1: false,
        }
    },
    computed: {
      dateFormated: {
         get: function () {
             return this.value
         },
         set: function (val) {
            this.$emit("input", val)
            //this.value = val;
         }
      }
    },
}
</script>

<style scoped>
  .v-text-field {
    cursor: pointer !important;
  }
</style>